import React, { Component } from 'react';
import Table from '../components/failures/Efects/Show'
import WebpackerReact from 'webpacker-react';

class EfectShow extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            showCreate: false,
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    updateStateCreate = (state) => {
        this.setState({ showCreate: state })
    }

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
            if (format.id === item.id) {
              return { ...item, 
                name: format.name,
              }
            }
            return item;
          })
        });
    }

    loadData = () => {
        fetch(`/failure/get_efect_activities/${this.props.efect.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            console.log(data)
          this.setState({
            data: data.data,
            showCreate: data.data.length >= 1 ? data.last.fallo : true,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                    efect={this.props.efect}
                    showCreate={this.state.showCreate}
                    updateStateCreate={this.updateStateCreate}
                    user={this.props.user}
                    type_count={this.props.type_count}
                />
            </React.Fragment>
        );
    }
}


export default EfectShow;
WebpackerReact.setup({ EfectShow });
